export function applySeo(config) {
  if (!config) return;

  if (config.seoTitle) {
    document.title = config.seoTitle;
  }

  const description = document.querySelector('meta[name="description"]');
  if (description && config.seoDescription) {
    description.setAttribute("content", config.seoDescription);
  }

  let keywords = document.querySelector('meta[name="keywords"]');
  if (!keywords) {
    keywords = document.createElement("meta");
    keywords.setAttribute("name", "keywords");
    document.head.appendChild(keywords);
  }
  if (config.seoKeywords) {
    keywords.setAttribute("content", config.seoKeywords);
  }
}

export function normalizeSiteConfig(res) {
  if (!res) return null;
  if (res.seoTitle || res.servicePhone || res.seoKeywords) return res;
  if (res.data && typeof res.data === "object") return res.data;
  return res;
}
